<h2 i18n><span>I</span>nsignias</h2>
<div id="badges_container">
    <div *ngFor="let badge of badges; let i = index"
        class="badge" id="badge{{i}}"
        (click)="clickBadge(i)"
        (keyup.enter)="clickBadge(i)"
        tabindex="0"
        #badge>     
        <div *ngIf="device === Device.Desktop && showImages" class="badge_preview desktop_image" ><img width="{{badge.image_width}}" height="{{badge.image_height}}" class="badge_image" src="{{badge.image}}" alt="{{badge.title}}"></div>
        <div *ngIf="device === Device.Mobile && showImages" class="badge_preview mobile_image"><img width="{{badge.image_mobile_width}}" height="{{badge.image_mobile_height}}" class="badge_image" src="{{badge.image_mobile}}" alt="{{badge.title}}"></div>
    </div>
</div>